/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useQuery } from '@apollo/client';
import { isNil, isNotNil } from 'es-toolkit';

import { DedicatedFreeCreditUsageDocument } from '@fai/friendli-suite/generated/client/graphql';

export const useDedicatedFreeCredit = (teamId: string) => {
  const { data: _data, loading } = useQuery(DedicatedFreeCreditUsageDocument, {
    variables: { teamId },
    fetchPolicy: 'network-only',
    pollInterval: 60000, // Changing of free credit is cannot be tracked, so polling is used in this query.
  });

  const _used = _data?.dedicatedSubplan?.freeCreditUsage?.used;
  const _total = _data?.dedicatedSubplan?.freeCreditUsage?.total;

  const used = isNil(_used) || isNaN(parseFloat(_used)) ? null : parseFloat(_used);
  const total = isNil(_total) || isNaN(parseFloat(_total)) ? null : parseFloat(_total);
  const remaining = isNotNil(used) && isNotNil(total) ? total - used : null;
  const isFreeCreditExist = isNotNil(remaining) && remaining > 0;

  return { used, total, remaining, isFreeCreditExist, loading };
};
